import ClassicBridge from '../next/ClassicBridge'
import {createActionObject} from '../redux/utils'
import * as ActionTypes from './actionTypes'

export const loadCustomFields = () => (dispatch) => {
    ClassicBridge.getTaskCustomFieldsList().then(({items}) => {
            dispatch(createActionObject(ActionTypes.CUSTOM_FIELDS_SET, items))
        }
    )
}

export const setCustomFields = (items) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.CUSTOM_FIELDS_SET, items))
}



// WEBPACK FOOTER //
// ./web/js/customFields/actions.js